// extracted by mini-css-extract-plugin
module.exports = {"stepsSection":"page_stepsSection__UtoPl","walkthrough":"page_walkthrough__QJqSw","stepNumber":"page_stepNumber__UyQcp","freeCopy":"page_freeCopy__JKnRa"};